<template>
  <div class="columns" v-if="service">
    <div class="is-half column">
      <service :service="service"></service>
    </div>
    <div class="is-half column">
      <occurrences-simple :service="service"></occurrences-simple>
      <br>
      <occurrences-simple :service="service" :internal="true" v-if="parseInt($store.state.config.user.level) < 99"></occurrences-simple>
      <br>
      <dispute :service="service" v-if="(parseInt($store.state.config.user.level) < 99) && (parseInt(service.dispute_v2) !== 0)"></dispute>
      <br>
      <!-- <dispute-old :service="service" v-if="parseInt($store.state.config.user.level) < 99"></dispute-old> -->
      <!-- <br> -->
      <financial :service="service" v-if="parseInt($store.state.config.user.level) < 99"></financial>
      <br>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel">
            <p class="panel-heading panel-heading-info" style="justify-content: space-between;">History Financial
              <button class="button is-success is-small" @click="loadHistoryFinancial()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_financial === 1">
              <historyFinancial :service="service"></historyFinancial>
            </p>
          </div>
        </div>
      </div>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel-success">
            <p class="panel-heading panel-heading-success" style="justify-content: space-between;">History Extend
              <button class="button is-info is-small" @click="loadHistoryExtend()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_extend === 1">
              <historyExtend :service="service"></historyExtend>
            </p>
          </div>
        </div>
      </div>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel-success">
            <p class="panel-heading panel-heading-success" style="justify-content: space-between;">History Clara
              <button class="button is-info is-small" @click="loadHistoryClara()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_clara === 1">
              <historyClara :service="service"></historyClara>
            </p>
          </div>
        </div>
      </div>
            <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel-success">
            <p class="panel-heading panel-heading-success" style="justify-content: space-between;">History Jeeves
              <button class="button is-info is-small" @click="loadHistoryJeeves()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_jeeves === 1">
              <historyJeeves :service="service"></historyJeeves>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import Service from '../../components/services/Service.vue'
  import OccurrencesSimple from '../../components/occurrences/OccurrencesSimple.vue'
  import DisputeOld from '../../components/services/Dispute.vue'
  import Dispute from '../../components/services/V2/Dispute.vue'
  import Financial from '../../components/services/Financial.vue'
  import HistoryFinancial from '../../components/services/HistoryFinancial.vue'
  import HistoryExtend from '../../components/services/HistoryExtend.vue'
  import HistoryClara from '../../components/services/HistoryClara.vue'
  import HistoryJeeves from '../../components/services/HistoryJeeves.vue'
  export default {
    data () {
      return {
        occurrences: null,
        service_id: null,
        service: null,
        load_history_financial: 0,
        load_history_extend: 0,
        load_history_clara: 0,
        load_history_jeeves: 0
      }
    },
    components: {
      Service,
      OccurrencesSimple,
      Dispute,
      DisputeOld,
      Financial,
      HistoryFinancial,
      HistoryExtend,
      HistoryClara,
      HistoryJeeves
    },
    mounted () {
      this.$nextTick(() => {
        this.service_id = this.$route.params.id
        this.loadData()
        this.$root.$on('reloadservice', reload => {
          this.loadData()
        })
      })
    },
    methods: {
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/services/' + this.service_id).then((response) => {
          this.service = response.body
          this.$root.$emit('booking_id', response.body.booking_id)
          this.$root.$emit('service_date', response.body.service_date)
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          return '#/services/client'
        })
      },
      loadHistoryFinancial () {
        this.load_history_financial = 1
        return this.load_history_financial
      },
      loadHistoryExtend () {
        this.load_history_extend = 1
        return this.load_history_extend
      },
      loadHistoryClara () {
        this.load_history_clara = 1
        return this.load_history_clara
      },
      loadHistoryJeeves () {
        this.load_history_jeeves = 1
        return this.load_history_jeeves
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  pre {
    background-color: #FFFFFF;
  }

  .tip {
    box-shadow: 0 2px 3px #2366d1, 0 0 0 1px #2366d1;
  }

  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-success {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
    color: #23d160;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-success {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
    background-color: rgb(35, 209, 96);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-heading-card {
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-info {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #3273dc;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-info {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
    background-color: rgb(50, 115, 220);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-warning {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
    color: #ffdd57;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-warning {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
    background-color: rgb(255, 221, 87);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Service.vue?6d05f0a2